module.exports = __webpack_public_path__ + "fonts/TwemojiCountryFlags.a19faae0.woff2";